export const NodeOperations = {
  DELETED: 0,
  UPDATED: 1,
  ADDED: 2,
  SELECTED: 3,
  CLICKED: 4,
  DOUBLECLICKED: 5,
  EXPANDED: 6,
  COLLAPSED: 7,
};

export const DefaultIconsClassNameMap = {
  expanded: 'glyph-caret-down',
  collapsed: 'glyph-caret-right',
  lastChild: '',
};

export const DefaultTreeViewClassName = 'tree-view-component';

export const DefaultNodePaddingLeft = 30;
export const DefaultCellHeight = 25;
